import { useEffect, useState, useRef} from 'react';
import { io } from 'socket.io-client'
import { base_url } from "../../utilities";
import axios from ".././../axios-interceptor";
import {getPmsNotifications} from '../../Redux/actions/actions';
import { PRINCIPAL_INVESTIGATOR, QUALITY_REVIEWER, MARKETING_STAFF, MEDICAL_REVIEWER, MARKETING_HEAD, PMS_ADMIN, PI_UPDATED_EVENT, PI_UPDATED_SUBJECT } from '../../utilities';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import {  getMHAdvEventOfSubject, getMHSubjProfDetails, getReviewerComments} from '../../Redux/actions/actions';

import { PI_ADDED_SUBJECT, QR_SUBJECT_REVIEW_APPROVED, QR_SUBJECT_REVIEW_REJECTED, PI_NEW_EVENT_REPORTED, PI_NEW_SERIOUS_EVENT_REPORTED, QR_EVENT_APPROVED,
  QR_EVENT_REJECTED, MR_EVENT_APPROVED, MR_EVENT_SENT_BACK_TO_PI, MR_EVENT_SENT_BACK_TO_QR, AD_NEW_SITE_CREATED } from '../../utilities';



const NotificationComponent = ({ closeNotification, notifications }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  

  const [notificationsToShow, setNotificationsToShow] = useState(10); // Initial number of notifications to show
  const notificationsToLoad = 10; // Number of notifications to load on each "Load More" click

  let rolecode = (localStorage.getItem("role_code"))
  const mhMainStudies = useSelector((state) => state.mhMainStudies);
  const getMrData = useSelector((state) => state.mrStudyList);
  const getQrData = useSelector((state) => state.qrStudyList);
  const msdropdowns = useSelector((state) => state.msdropdowns);
  const notificationRef = useRef(null);

  // Function to close the notification
  const handleCloseNotification1 = () => {
    closeNotification();
  };
  
  // Add a click event listener to the document
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        
        handleCloseNotification1();
      }
    };
    
    document.addEventListener('click', handleClickOutside);
  
    // Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  const handleCloseNotification = (id) => {
    axios
      .post(base_url + "notifications/read_notification",{
        notification_id: id,
        user_id: localStorage.login_user_id
      })
      .then((response) => {
      
        if (rolecode == PMS_ADMIN) {
          dispatch(getPmsNotifications({
            user_id: localStorage.login_user_id,
            user_persona: PMS_ADMIN
          }))
        }
        if (rolecode == MARKETING_HEAD) {
          dispatch(getPmsNotifications({
            user_id: localStorage.login_user_id,
            user_persona: MARKETING_HEAD,
            study_id: mhMainStudies?.map(item => item.study_id),
            zone_id: localStorage.getItem("mh_zone_id")
          }))
        }

        if (rolecode == MEDICAL_REVIEWER) {
          dispatch(getPmsNotifications({
            user_id: localStorage.login_user_id,
            user_persona: MEDICAL_REVIEWER,
            study_id: getMrData?.map(item => item.study_id)
          }))
        }
        if (rolecode == QUALITY_REVIEWER) {
          dispatch(getPmsNotifications({
            user_id: localStorage.login_user_id,
            user_persona: QUALITY_REVIEWER,
            study_id: getQrData?.map(item => item.study_id)
          }))
        }
        if (rolecode == MARKETING_STAFF) {
          dispatch(getPmsNotifications({
            user_id: localStorage.login_user_id,
            user_persona: MARKETING_STAFF,
            study_id: msdropdowns?.map(item => item.study_id)
          }))
        }
        if (rolecode == PRINCIPAL_INVESTIGATOR) {
          
          dispatch(getPmsNotifications({
            user_id: localStorage.login_user_id,
            pi_id:localStorage.pi_id,
            user_persona: PRINCIPAL_INVESTIGATOR
          }))
        }
      })
      .catch((error) => {
        console.log(error)
      });
  }

  const loadMoreNotifications = (event) => {
    // Increase the number of notifications to show
    event.stopPropagation();
    setNotificationsToShow((prevNotificationsToShow) => prevNotificationsToShow + notificationsToLoad);
  };
  // Function to format the date and time
function formatDateTime(isoString) {
  const date = new Date(isoString);
  return `${date.getFullYear()}-${(date.getMonth() + 1)
    .toString()
    .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date
    .getHours()
    .toString()
    .padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date
    .getSeconds()
    .toString()
    .padStart(2, '0')}`;
}

  

  return (
    <div  ref={notificationRef}>
      <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", padding: "10px", borderBottom: "1px solid #e0e0e0" }}>
        <span style={{ fontSize: "20px" }}>Notifications</span>
        <img
            src={'./images/icons/closeIcon.svg'}
            style={{ height: "16px", cursor: "pointer" }}
            alt='close'
            onClick={closeNotification}
          />
      </div>
      {notifications.length === 0 ? 
        <div style={{display:"flex", justifyContent:"center", margin:"30px"}}>
        <span>No Notifications</span>
        </div>
        :
      
      <>
      {notifications?.slice(0, notificationsToShow).map((notification, index) => (
        <div  className='notificationHead' key={index}>
          <div style={{display: "flex", flexDirection: "row", justifyContent:"end",paddingRight: "4px" }}>
            <span style={{ fontSize: "12px" }}>
              {formatDateTime(notification.updatedAt)}
            </span>
          </div>
          <div className="notification">
            <div style={{ backgroundColor: "green", padding: "4px", height: "2px", width: "2px", marginTop: "8px", marginRight: "20PX", borderRadius: "20px"}}></div>
            {notification.notification_type === PI_ADDED_SUBJECT ?
            <span style={{ margin: "0px", padding: "0px", textAlign: "left", fontSize:"14px"}}>New Subject has been added with ID <b>{notification.subject_code}</b> for study <b>{notification.study_name}</b> and site <b>{notification.site_code}</b></span>
              :
              null
            }
            {notification.notification_type === QR_SUBJECT_REVIEW_APPROVED ?
            <span style={{ margin: "0px", padding: "0px", textAlign: "left", fontSize:"14px" }}>Review approved for subject <b>{notification.subject_code}</b> for study <b>{notification.study_name}</b> </span>
              :
              null
            }
            {notification.notification_type === QR_SUBJECT_REVIEW_REJECTED ?
            <span style={{ margin: "0px", padding: "0px", textAlign: "left",  fontSize:"14px" }}>Review rejected for subject <b>{notification.subject_code}</b> for study <b>{notification.study_name}</b> </span>
              :
              null
            }
            {notification.notification_type === PI_NEW_EVENT_REPORTED ?
            <span style={{ margin: "0px", padding: "0px", textAlign: "left", fontSize:"14px" }}>New event <b>{notification.event_name}</b> reported for subject <b>{notification.subject_code}</b> for study <b>{notification.study_name}</b></span>
              :
              null
            }
            {notification.notification_type === PI_NEW_SERIOUS_EVENT_REPORTED ?
            // redirect to subject event page
            <span style={{ margin: "0px", padding: "0px", textAlign: "left", fontSize:"14px" }}>New serious adverse event <b>{notification.event_name}</b> has been reported for subject <b>{notification.subject_code}</b> in study <b>{notification.study_name}</b></span>
              :
              null
            }
            {notification.notification_type === QR_EVENT_APPROVED ?
            <span style={{ margin: "0px", padding: "0px", textAlign: "left", fontSize:"14px" }}>Event <b>{notification.event_name}</b> escalated for subject <b>{notification.subject_code}</b> in study <b>{notification.study_name}</b> </span>
              :
              null
            }
            {notification.notification_type === QR_EVENT_REJECTED ?
            <span style={{ margin: "0px", padding: "0px", textAlign: "left", fontSize:"14px" }}>Event <b>{notification.event_name}</b> sent back by Quality Reviewer with comment <b>{notification.comment}</b> for subject <b>{notification.subject_code}</b></span>
              :
              null
            }
            {notification.notification_type === MR_EVENT_APPROVED ?
            <span style={{ margin: "0px", padding: "0px", textAlign: "left", fontSize:"14px" }}>Event <b>{notification.event_name}</b> approved by Medical Reviewer for subject <b>{notification.subject_code}</b> in study <b>{notification.study_name}</b> </span>
              :
              null
            }
            {notification.notification_type === MR_EVENT_SENT_BACK_TO_PI ?
            <span style={{ margin: "0px", padding: "0px", textAlign: "left", fontSize:"14px" }}>Event <b>{notification.event_name}</b> sent back by Medical Reviewer with comment <b>{notification.comment}</b> for subject <b>{notification.subject_code}</b></span>
              :
              null
            }
            {notification.notification_type === MR_EVENT_SENT_BACK_TO_QR ?
            <span style={{ margin: "0px", padding: "0px", textAlign: "left", fontSize:"14px" }}>Event <b>{notification.event_name}</b> sent back by Medical Reviewer with comment <b>{notification.comment} for subject <b>{notification.subject_code}</b></b></span>
              :
              null
            }
            {notification.notification_type === AD_NEW_SITE_CREATED ?
            <span style={{ margin: "0px", padding: "0px", textAlign: "left", fontSize:"14px" }}>New site <b>{notification.site_name}</b> created with site code <b>{notification.site_code}</b> in city <b>{notification.city_name}</b></span>
              :
              null
            }

            {notification.notification_type === PI_UPDATED_EVENT ?
            <span style={{ margin: "0px", padding: "0px", textAlign: "left", fontSize:"14px" }}>Event <b>{notification.event_name}</b> for subject {notification.subject_code} has been updated by the principal investigator for study {notification.study_name} </span>
              :
              null
            }

            {notification.notification_type === PI_UPDATED_SUBJECT ?
            <span style={{ margin: "0px", padding: "0px", textAlign: "left", fontSize:"14px" }}>Subject <b>{notification.subject_code}</b> has been updated by the principal investigator for study {notification.study_name} </span>
              :
              null
            }
            <img className="pointer-on-hover" src={"./images/icons/VectorcloseCircle.svg"} alt="close" onClick={() => handleCloseNotification(notification.notification_id)}/>
          </div>
          
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "end", marginTop: "-10px" }} >
            {notification.notification_type === PI_ADDED_SUBJECT ?
                  <>
                  {
                        localStorage.getItem('role_code') == PMS_ADMIN?
                      <div className="pointer-on-hover" onClick={()=>
                        {
                          localStorage.setItem("study_id", notification.study_id)
                          handleCloseNotification(notification.notification_id)
                          if(window.location.pathname === '/pmsadminlistofsubjects'){
                            
                            const randomKey = Math.random().toString();
                            navigate("/pmsadminlistofsubjects", {
                              state: {
                                  data: {
                                    subject_id:notification.subject_id,
                                    dose:"D1",
                                  }
                              }, key: randomKey });
                              window.location.reload()
                          }
                          else{
                            navigate("/pmsadminlistofsubjects", {
                              state: {
                                  data: {
                                    subject_id:notification.subject_id,
                                    dose:"D1",
                                  }
                              }
                          }
                            )
                          }
                        }
                        }>
                        <span style={{ fontSize: "12px" }}>View Details</span>
                        <img src={'./images/icons/Grouparrow.svg'} alt="" />
                      </div>
                    :
                    null
                  }

                  {
                        localStorage.getItem('role_code') == QUALITY_REVIEWER?
                      <div className="pointer-on-hover" onClick={()=>
                      {
                        localStorage.setItem("study_id", notification.study_id)
                        handleCloseNotification(notification.notification_id)
                        if(window.location.pathname === '/qrsubjectreview'){
                          
                          const randomKey = Math.random().toString();
                          navigate("/qrsubjectreview", {
                            state: {
                                data: {
                                  subject_id:notification.subject_id,
                                  dose:1,
                                }
                            }, key: randomKey });
                            window.location.reload()
                        }
                        else{
                          navigate("/qrsubjectreview", {
                            state: {
                                data: {
                                  subject_id:notification.subject_id,
                                  dose:1,
                                }
                            }
                        }
                          )
                        }
                      }
                      }>
                        <span style={{ fontSize: "12px" }}>View Details</span>
                        <img src={'./images/icons/Grouparrow.svg'} alt="" />
                      </div>
                    :
                    null
                  }
                  {
                        localStorage.getItem('role_code') == MARKETING_HEAD?
                      <div className="pointer-on-hover" onClick={()=>{
                        localStorage.setItem("study_id", notification.study_id)
                        dispatch(getMHAdvEventOfSubject(notification.subject_id, 1))
                        dispatch(getMHSubjProfDetails({ subject_id: notification.subject_id, dose: 1 }))
                        handleCloseNotification(notification.notification_id)
                        navigate("/mhsubjectlist", {
                          state: {
                              data: 2,
                          }
                      })}
                      }>
                        <span style={{ fontSize: "12px" }}>View Details</span>
                        <img src={'./images/icons/Grouparrow.svg'} alt="" />
                      </div>
                    :
                    null
                  }
                  {
                        localStorage.getItem('role_code') == MARKETING_STAFF?
                      <div className="pointer-on-hover" onClick={()=>{
                        localStorage.setItem("study_id", notification.study_id)
                        handleCloseNotification(notification.notification_id)
                        if(window.location.pathname === '/marketingstaffsubjectlist'){
                          
                          const randomKey = Math.random().toString();
                          navigate("/marketingstaffsubjectlist", {
                            state: {
                                data: {
                                  subject_id:notification.subject_id,
                                  dose:"D1",
                                }
                            }, key: randomKey });
                            window.location.reload()
                        }
                        else{
                          navigate("/marketingstaffsubjectlist", {
                            state: {
                                data: {
                                  subject_id:notification.subject_id,
                                  dose:"D1",
                                }
                            }
                        }
                          )
                        }
                        
                       
                        }}>
                        <span style={{ fontSize: "12px" }}>View Details</span>
                        <img src={'./images/icons/Grouparrow.svg'} alt="" />
                      </div>
                    :
                    null
                  }
                  </>
                :
                null
              }

              {notification.notification_type === QR_SUBJECT_REVIEW_APPROVED ?
              // pms and pi persona
              <>
              {
                localStorage.getItem('role_code') == PRINCIPAL_INVESTIGATOR ?
                  <div className="pointer-on-hover" onClick={()=>{
                  localStorage.setItem("study_id", notification.study_id)
                  handleCloseNotification(notification.notification_id)

                  if(window.location.pathname === '/pisubjectslist'){
                    
                    const randomKey = Math.random().toString();
                    navigate("/pisubjectslist", {
                      state: {
                          data: {
                            subject_id:notification.subject_id,
                            dose:"D1"
                          }
                      }, key: randomKey });
                      window.location.reload()
                  }
                  else{
                    navigate("/pisubjectslist", {
                      state: {
                          data: {
                            subject_id:notification.subject_id,
                            dose:"D1"
                          }
                      }
                  }
                    )
                  }
                  
                }}>
                  <span style={{ fontSize: "12px" }}>View Details</span>
                  <img src={'./images/icons/Grouparrow.svg'} alt="" />
                </div>
                :
                null
              }
              {localStorage.getItem('role_code') == PMS_ADMIN ?
              <div className="pointer-on-hover" onClick={()=>{
                localStorage.setItem("study_id", notification.study_id)
                handleCloseNotification(notification.notification_id)

                if(window.location.pathname === '/pmssubjectsreview'){
                  
                  const randomKey = Math.random().toString();
                  navigate("/pmssubjectsreview", {
                    state: {
                        data: {
                          subject_id:notification.subject_id,
                          review_status:2
                        }
                    }, key: randomKey });
                    window.location.reload()
                }
                else{
                  navigate("/pmssubjectsreview", {
                    state: {
                        data: {
                          subject_id:notification.subject_id,
                          review_status:2
                        }
                    }
                }
                  )
                }
                
              }}>
                <span style={{ fontSize: "12px" }}>View Details</span>
                <img src={'./images/icons/Grouparrow.svg'} alt="" />
              </div>
                  :
              null
              }
              </>
                
                :
                null
              }
              {/* checking */}
              {notification.notification_type === QR_SUBJECT_REVIEW_REJECTED ?
              // pi persona
                <div className="pointer-on-hover" onClick={()=>{
                  localStorage.setItem("study_id", notification.study_id)
                  handleCloseNotification(notification.notification_id)

                  if(window.location.pathname === '/rejectedsubjects'){
                    
                    const randomKey = Math.random().toString();
                    navigate("/rejectedsubjects", {
                      state: {
                          data: {
                            subject_id:notification.subject_id,
                            dose:1
                          }
                      }, key: randomKey });
                      // window.location.reload()
                  }
                  else{
                    navigate("/rejectedsubjects", {
                      state: {
                          data: {
                            subject_id:notification.subject_id,
                            dose:1
                          }
                      }
                  }
                    )
                  }
                  
                }}>
                  <span style={{ fontSize: "12px" }}>View Details</span>
                  <img src={'./images/icons/Grouparrow.svg'} alt="" />
                </div>
                :
                null
              }

              {notification.notification_type === PI_NEW_EVENT_REPORTED ?
              // qr persona
                <div className="pointer-on-hover" onClick={()=>{
                  localStorage.setItem("study_id", notification.study_id)
                  handleCloseNotification(notification.notification_id)
                  if(window.location.pathname === '/reviewlist'){
                    
                    const randomKey = Math.random().toString();
                    navigate("/reviewlist", {
                      state: {
                          data: {
                            subject_id:notification.subject_id,
                            dose:1,
                            adverse_event_id: notification.event_id,
                            status: 0
                          }
                      }, key: randomKey });
                      window.location.reload()
                  }
                  else{
                    navigate("/reviewlist", {
                      state: {
                          data: {
                            subject_id:notification.subject_id,
                            dose:1,
                            adverse_event_id: notification.event_id,
                            status: 0
                          }
                      }
                  }
                    )
                  }

                }}>
                  <span style={{ fontSize: "12px" }}>View Details</span>
                  <img src={'./images/icons/Grouparrow.svg'} alt="" />
                </div>
                :
                null
              }

              {notification.notification_type === PI_UPDATED_EVENT ?
              // qr persona
                <div className="pointer-on-hover" onClick={()=>{
                  localStorage.setItem("study_id", notification.study_id)
                  handleCloseNotification(notification.notification_id)
                  if(window.location.pathname === '/reviewlist'){
                    
                    const randomKey = Math.random().toString();
                    navigate("/reviewlist", {
                      state: {
                          data: {
                            subject_id:notification.subject_id,
                            dose:1,
                            adverse_event_id: notification.event_id,
                            status: 0
                           
                          }
                      }, key: randomKey });
                      window.location.reload()
                  }
                  else{
                    navigate("/reviewlist", {
                      state: {
                          data: {
                            subject_id:notification.subject_id,
                            dose:1,
                            adverse_event_id: notification.event_id,
                            status: 0
                          }
                      }
                  }
                    )
                  }

                }}>
                  <span style={{ fontSize: "12px" }}>View Details</span>
                  <img src={'./images/icons/Grouparrow.svg'} alt="" />
                </div>
                :
                null
              }

              {notification.notification_type === PI_UPDATED_SUBJECT ?
              // qr persona
                <div className="pointer-on-hover" onClick={()=>{
                  localStorage.setItem("study_id", notification.study_id)
                  handleCloseNotification(notification.notification_id)
                  if(window.location.pathname === '/qrsubjectreview'){
                    
                    const randomKey = Math.random().toString();
                    navigate("/qrsubjectreview", {
                      state: {
                        data: {
                          subject_id:notification.subject_id,
                          dose:1,
                        }
                      }, key: randomKey });
                      window.location.reload()
                  }
                  else{
                    navigate("/qrsubjectreview", {
                      state: {
                        data: {
                          subject_id:notification.subject_id,
                          dose:1,
                        }
                      }
                  }
                    )
                  }

                }}>
                  <span style={{ fontSize: "12px" }}>View Details</span>
                  <img src={'./images/icons/Grouparrow.svg'} alt="" />
                </div>
                :
                null
              }

              {notification.notification_type === PI_NEW_SERIOUS_EVENT_REPORTED ?
              // qr and pms 
              <>
              {
                localStorage.getItem('role_code') == PMS_ADMIN?
                        <div className="pointer-on-hover" onClick={()=>{
                          localStorage.setItem("study_id", notification.study_id)
                          handleCloseNotification(notification.notification_id)
                          if(window.location.pathname === '/pmsadminlistofsubjects'){
                            
                            const randomKey = Math.random().toString();
                            navigate("/pmsadminlistofsubjects", {
                              state: {
                                  data: {
                                    subject_id:notification.subject_id,
                                    dose:"D1",
                                    adverse_event_id: notification.event_id,
                                    status: 0
                                  }
                              }, key: randomKey });
                              window.location.reload()
                          }
                          else{
                            navigate("/pmsadminlistofsubjects", {
                              state: {
                                  data: {
                                    subject_id:notification.subject_id,
                                    dose:"D1",
                                    adverse_event_id: notification.event_id,
                                    status: 0
                                  }
                              }
                          }
                            )
                          }
        
                        }}>
                            
                            <span style={{ fontSize: "12px" }}>View Details</span>
                            <img src={'./images/icons/Grouparrow.svg'} alt="" />
                          </div>
                          :
                          null}

                      {
                      localStorage.getItem('role_code') == QUALITY_REVIEWER?
                        <div className="pointer-on-hover" onClick={()=>{
                          localStorage.setItem("study_id", notification.study_id)
                          handleCloseNotification(notification.notification_id)
                          if(window.location.pathname === '/reviewlist'){
                            
                            const randomKey = Math.random().toString();
                            navigate("/reviewlist", {
                              state: {
                                  data: {
                                    subject_id:notification.subject_id,
                                    dose:1,
                                    adverse_event_id: notification.event_id,
                                    status: 0
                                  }
                              }, key: randomKey });
                              window.location.reload()
                          }
                          else{
                            navigate("/reviewlist", {
                              state: {
                                  data: {
                                    subject_id:notification.subject_id,
                                    dose:1,
                                    adverse_event_id: notification.event_id,
                                    status: 0
                                  }
                              }
                          }
                            )
                          }
        
                        }}>
                            
                            <span style={{ fontSize: "12px" }}>View Details</span>
                            <img src={'./images/icons/Grouparrow.svg'} alt="" />
                          </div>
                          :
                          null}
              
              </>
                
                :
                null
              }

              {notification.notification_type === QR_EVENT_APPROVED ?
              // mr 
                <div className="pointer-on-hover" onClick={()=>{
                  localStorage.setItem("study_id", notification.study_id)
                  handleCloseNotification(notification.notification_id)
                  if(window.location.pathname === '/mrreviewlist'){
                    const randomKey = Math.random().toString();
                    navigate("/mrreviewlist", {
                      state: {
                          data: {
                            // subject_id: "b464bdd1-49a4-4325-8222-2116f00982a9",
                            subject_id:notification.subject_id,
                            dose:1,
                            // adverse_event_id: "a6c1a929-f96c-4b19-8d6f-b8f48634d71e",
                            adverse_event_id:notification.event_id,
                            status: 1
                          }
                      }, key: randomKey });
                      window.location.reload()
                  }
                  else{
                    navigate("/mrreviewlist", {
                      state: {
                          data: {
                            // subject_id: "b464bdd1-49a4-4325-8222-2116f00982a9",
                            subject_id:notification.subject_id,
                            dose:1,
                            // adverse_event_id: "a6c1a929-f96c-4b19-8d6f-b8f48634d71e",
                            adverse_event_id:notification.event_id,
                            status: 1
                          }
                      }
                  }
                    )
                  }
                
                }
                }>
                  <span style={{ fontSize: "12px" }}>View Details</span>
                  <img src={'./images/icons/Grouparrow.svg'} alt="" />
                </div>
                :
                null
              }

              {notification.notification_type === QR_EVENT_REJECTED ?
              // pi
                <div className="pointer-on-hover" onClick={()=>{
                  localStorage.setItem("study_id", notification.study_id)
                  handleCloseNotification(notification.notification_id)
                  if(window.location.pathname === '/pirejectedevents'){
                    
                    const randomKey = Math.random().toString();
                    navigate("/pirejectedevents", {
                      state: {
                          data: {
                            subject_id:notification.subject_id,
                            dose:1,
                            adverse_event_id: notification.event_id,
                          }
                      }, key: randomKey });
                      window.location.reload()
                  }
                  else{
                    navigate("/pirejectedevents", {
                      state: {
                          data: {
                            subject_id:notification.subject_id,
                            dose:1,
                            adverse_event_id: notification.event_id,
                          }
                      }
                  }
                    )
                  }
                
                }
                }>
                  <span style={{ fontSize: "12px" }}>View Details</span>
                  <img src={'./images/icons/Grouparrow.svg'} alt="" />
                </div>
                :
                null
              }

              {notification.notification_type === MR_EVENT_APPROVED ?
              // pi and qr
              <>
                {
                  localStorage.getItem('role_code') == PRINCIPAL_INVESTIGATOR?
                    <div className="pointer-on-hover" onClick={()=>{
                      localStorage.setItem("study_id", notification.study_id)
                      handleCloseNotification(notification.notification_id)
                      if(window.location.pathname === '/pirejectedevents'){
                        
                        const randomKey = Math.random().toString();
                        navigate("/pirejectedevents", {
                          state: {
                              data: {
                                subject_id:notification.subject_id,
                                dose:1,
                                adverse_event_id: notification.event_id,
                              }
                          }, key: randomKey });
                          window.location.reload()
                      }
                      else{
                        navigate("/pirejectedevents", {
                          state: {
                              data: {
                                subject_id:notification.subject_id,
                                dose:1,
                                adverse_event_id: notification.event_id,
                              }
                          }
                      }
                        )
                      }
    
                    }}>
                      <span style={{ fontSize: "12px" }}>View Details</span>
                      <img src={'./images/icons/Grouparrow.svg'} alt="" />
                    </div>
                    :
                    null
                }

                  {
                  localStorage.getItem('role_code') == QUALITY_REVIEWER?
                    <div className="pointer-on-hover" onClick={()=>{
                      localStorage.setItem("study_id", notification.study_id)
                      handleCloseNotification(notification.notification_id)
                      if(window.location.pathname === '/reviewlist'){
                        
                        const randomKey = Math.random().toString();
                        navigate("/reviewlist", {
                          state: {
                              data: {
                                subject_id:notification.subject_id,
                                dose:1,
                                adverse_event_id: notification.event_id,
                                status: 2
                              }
                          }, key: randomKey });
                          window.location.reload()
                      }
                      else{
                        navigate("/reviewlist", {
                          state: {
                              data: {
                                subject_id:notification.subject_id,
                                dose:1,
                                adverse_event_id: notification.event_id,
                                status: 2
                              }
                          }
                      }
                        )
                      }
    
                    }}>
                      <span style={{ fontSize: "12px" }}>View Details</span>
                      <img src={'./images/icons/Grouparrow.svg'} alt="" />
                    </div>
                    :
                    null
                }
              
              </>
              :
              null
                
              }

              {notification.notification_type === MR_EVENT_SENT_BACK_TO_PI ?
              // pi
                <div className="pointer-on-hover" onClick={()=>{
                  localStorage.setItem("study_id", notification.study_id)
                  handleCloseNotification(notification.notification_id)
                  if(window.location.pathname === '/pirejectedevents'){
                    
                    const randomKey = Math.random().toString();
                    navigate("/pirejectedevents", {
                      state: {
                          data: {
                            subject_id:notification.subject_id,
                            dose:1,
                            adverse_event_id: notification.event_id,
                          }
                      }, key: randomKey });
                      window.location.reload()
                  }
                  else{
                    navigate("/pirejectedevents", {
                      state: {
                          data: {
                            subject_id:notification.subject_id,
                            dose:1,
                            adverse_event_id: notification.event_id,
                          }
                      }
                  }
                    )
                  }

                }}>
                  <span style={{ fontSize: "12px" }}>View Details</span>
                  <img src={'./images/icons/Grouparrow.svg'} alt="" />
                </div>
                :
                null
              }

              {notification.notification_type === MR_EVENT_SENT_BACK_TO_QR ?
              // qr
                <div className="pointer-on-hover" onClick={()=>{
                  localStorage.setItem("study_id", notification.study_id)
                  handleCloseNotification(notification.notification_id)
                  if(window.location.pathname === '/reviewlist'){
                    
                    const randomKey = Math.random().toString();
                    navigate("/reviewlist", {
                      state: {
                          data: {
                            subject_id:notification.subject_id,
                            dose:1,
                            adverse_event_id: notification.event_id,
                            status: 3
                          }
                      }, key: randomKey });
                      window.location.reload()
                  }
                  else{
                    navigate("/reviewlist", {
                      state: {
                          data: {
                            subject_id:notification.subject_id,
                            dose:1,
                            adverse_event_id: notification.event_id,
                            status: 3
                          }
                      }
                  }
                    )
                  }

                }}>
                  <span style={{ fontSize: "12px" }}>View Details</span>
                  <img src={'./images/icons/Grouparrow.svg'} alt="" />
                </div>
                :
                null
              }

              {/* {notification.notification_type === AD_NEW_SITE_CREATED ?
              // mh
                <div className="pointer-on-hover" onClick={()=>{
                  localStorage.setItem("study_id", notification.study_id)
                  handleCloseNotification(notification.notification_id)
                  navigate("/mhsitesdetails")}
                }>
                  <span style={{ fontSize: "12px" }}>View Details</span>
                  <img src={'./images/icons/Grouparrow.svg'} alt="" />
                </div>
                :
                null
              } */}
            
          </div>
        </div>
      ))}
      </>
      }
      {notificationsToShow < notifications?.length && (
        <div style={{ textAlign: "center", padding: "10px" }}>
          <button onClick={loadMoreNotifications} style={{border:"0px", color:"blue", backgroundColor:"white"}}>Load More</button>
        </div>
      )}
    </div>
  );
};

export default NotificationComponent;
